import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-[#141414] border border-white/10 flex items-center justify-center">
              <Lock className="text-[#D4AF37]" size={28} />
            </div>
          </div>
          <h1 className="text-4xl font-light tracking-tighter text-white" data-testid="admin-login-title">
            Admin Access
          </h1>
          <p className="text-[#A3A3A3]">Sign in to manage your store</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#141414] border border-white/10 p-8 space-y-6">
          {error && (
            <div className="bg-[#FF3B30]/10 border border-[#FF3B30]/20 p-4 text-center" data-testid="login-error-message">
              <p className="text-[#FF3B30] text-sm">{error}</p>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-[#A3A3A3] block mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] text-white px-0 py-3 outline-none transition-colors"
                placeholder="admin@savistones.com"
                data-testid="admin-email-input"
              />
            </div>

            <div>
              <label className="text-xs uppercase tracking-wider text-[#A3A3A3] block mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] text-white px-0 py-3 outline-none transition-colors"
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full px-10 py-4 bg-[#D4AF37] text-black font-medium tracking-wide uppercase text-sm hover:bg-[#F1E5AC] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="admin-login-button"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-xs text-[#A3A3A3]">
          Default credentials: admin@savistones.com / admin123
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;